module.exports = __webpack_public_path__ + "static/media/Design.718c23fa.png";